import React from 'react'
import "./Navbar.css"

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="logo"><a href="/">Milo Peterson</a></div>
      <ul className="nav-links">
        <li><a href="/">Posts</a></li>
        <li><a href="/about">Info</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </nav>
  )
}

export default Navbar
